import React, { useState } from 'react';
import { X, Plus } from 'lucide-react';

export function TagEditor({ tags = [], onChange, suggestions = [], placeholder = 'Add tag...' }) {
  const [input, setInput] = useState('');

  const addTag = (tag) => {
    const trimmed = tag.trim();
    if (trimmed && !tags.includes(trimmed)) {
      onChange([...tags, trimmed]);
    }
    setInput('');
  };

  const removeTag = (tag) => {
    onChange(tags.filter(t => t !== tag));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addTag(input);
    } else if (e.key === 'Backspace' && !input && tags.length > 0) {
      removeTag(tags[tags.length - 1]);
    }
  };

  const filteredSuggestions = suggestions.filter(s => !tags.includes(s) && s.toLowerCase().includes(input.toLowerCase()));

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2 p-2 border border-stone-200 rounded-lg min-h-[42px] focus-within:border-amber-400 transition-colors">
        {tags.map(tag => (
          <span key={tag} className="inline-flex items-center gap-1 px-2 py-1 bg-amber-100 text-amber-800 rounded text-sm">
            {tag}
            <button onClick={() => removeTag(tag)} className="hover:text-amber-600">
              <X className="w-3 h-3" />
            </button>
          </span>
        ))}
        <input
          type="text"
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={tags.length === 0 ? placeholder : ''}
          className="flex-1 min-w-[100px] outline-none text-sm bg-transparent"
        />
      </div>
      {input && filteredSuggestions.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {filteredSuggestions.slice(0, 5).map(s => (
            <button key={s} onClick={() => addTag(s)} className="px-2 py-0.5 text-xs bg-stone-100 hover:bg-amber-100 rounded transition-colors">
              + {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
